<script>

    import { toast } from 'bulma-toast'
    import { usersStore, modalStore } from '../stores'

    import UsersService from '../$services/users.service'

    import Form from '../$components/form.svelte'
    import InputText from '../$components/input.text.svelte'
    import ButtonSave from '../$components/button.save.svelte'
    import ButtonCancel from '../$components/button.cancel.svelte'

    let loading = false
    let data = {}

    async function createUser() {

        loading = true
        const resp = await UsersService.createUser(data)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        toast({message: 'Usuario creado', type: 'is-success'})

        usersStore.append(resp.data)
        modalStore.close()
    }

</script>

<Form on:submit={createUser} {loading} >

    <div class="columns">
        <div class="column">
            <InputText bind:value={data.firstName} label="Nombre" placeholder="Nombre" />
        </div>
        <div class="column">
            <InputText bind:value={data.lastName} label="Apellidos" placeholder="Apellidos" />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <InputText bind:value={data.corporate} label="Empresa" placeholder="Empresa" required={false} />
        </div>
        <div class="column">
            <InputText bind:value={data.phone} label="Teléfono" placeholder="Teléfono" />
        </div>
    </div>

    <div class="columns">
        <div class="column">
            <InputText bind:value={data.email} label="Correo" placeholder="Correo" />
        </div>
        <div class="column">
            <InputText bind:value={data.password} label="Contraseña" placeholder="Contraseña" />
        </div>
    </div>

    <div class="is-flex is-justify-content-flex-end is-align-items-center">
        <ButtonCancel on:click={modalStore.close} />
        <ButtonSave />
    </div>

</Form>